import { useNavigate } from "react-router-dom";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Sparkles, Check } from "lucide-react";

const PREMIUM_PERKS = [
  "Custom invoice & contract branding",
  "Automatic payment reminders & late fees",
  "AI Estimate Calculator",
  "Lead capture (CRM)",
  "Contracts & e-signatures",
  "Reference photos by room",
];

export function UpgradeDialog({ open, onOpenChange, feature }) {
  const navigate = useNavigate();
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="upgrade-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 font-display">
            <Sparkles className="h-5 w-5 text-primary" />
            {feature ? `${feature} is a Premium feature` : "Upgrade to Premium"}
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3">
              <p>Upgrade to the Premium plan ($69/mo) to unlock:</p>
              <ul className="space-y-1.5">
                {PREMIUM_PERKS.map((p) => (
                  <li key={p} className="flex items-start gap-2 text-sm text-foreground">
                    <Check className="h-4 w-4 text-primary shrink-0 mt-0.5" /> {p}
                  </li>
                ))}
              </ul>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="upgrade-cancel">Maybe later</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => navigate("/owner/billing")}
            data-testid="upgrade-go-billing"
          >
            View plans
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
